module.exports = __webpack_public_path__ + "static/live-intro2-601c85049f2798a5aa542ab477a03970.jpg";